export default {
  alert: {
    alertMessage: 'Sentiment, Theme, and Tag data may be unavailable for TikTok posts. TikTok pages remain selectable, but these filters may return no results.',
    linkText: 'Learn more in the Help Center',
  },
};
